// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__gOz0h","tomboButton":"Form_tomboButton__hj62x"};